import { AppText } from "@toothfairy/shared-ui";
import AppAssets from "@toothfairy/shared-ui/AppAssets";
import AppBaseScreen from "@toothfairy/shared-ui/AppBaseScreen";
import AppButtonMenu from "@toothfairy/shared-ui/AppButtonMenu";
import AppChoice from "@toothfairy/shared-ui/AppChoice";
import AppDropDown from "@toothfairy/shared-ui/AppDropDown";
import AppModal from "@toothfairy/shared-ui/AppModal";
import AppPlaceholderView from "@toothfairy/shared-ui/AppPlaceholderView";
import AppQuantumEditorUtils from "@toothfairy/shared-ui/AppQuantumEditorUtils";
import AppStateManager from "@toothfairy/shared-ui/AppStateManager";
import AppTable from "@toothfairy/shared-ui/AppTable";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Platform, StyleSheet, View, useWindowDimensions } from "react-native";
import LoadingPlaceholder from "../../Components/LoadingPlaceholder";
import Notification from "../../Components/Notification";
import PageTitle from "../../Components/PageTitle";
import ToothFairyButton from "../../Components/ToothFairyComponents/ToothFairyButton";
import ToothFairySupportButton from "../../Components/ToothFairyComponents/ToothFairySupportButton";
import ToothFairySwitch from "../../Components/ToothFairyComponents/ToothFairySwitch";
import useWorkspaces from "../../Hooks/useWorkspaces";
import {
  isLargeScreen,
  isMobileScreen,
  minAppWidth,
} from "../MainViewContainer";
import { emptyTitleValue } from "../TestExample/commonUtils";
import DocumentsImportWizard from "./Components/DocumentsImportWizard";
import Styles from "../Styles/Styles";
import Constants from "../../Constants";
const DocumentsScreen = ({
  onDeleteSelectedItem,
  currentPage,
  onItemPress,
  items,
  selectedItems,
  trainingData,
  hasAnyData,
  requestInProgress,
  NERStyles,
  IntentStyles,
  handleDocumentSelection,
  handleDocumentDeletion,
  handleBulkDocumentDeletion = () => {},
  handlePageChange = () => {},
  handleChangeText = () => {},
  textString,
  documentIdString,
  handleChangeDocumentIdString,
  isImportInProgress,
  isImportStarted,
  importProgress,
  isImportEnabled,
  stopImportProcess,
  handleExcludeValidation,
  excludeValidation,
  handleDocumentCreation = () => {},
  createAPIInProgress,
  typeFilter,
  setTypeFilter,
  documentTypes,
  isImportWizardOpen,
  setIsImportWizardOpen,
  selectedImportType,
  setSelectedImportType,
  handleFileSelect,
  handleImportsGeneric = () => {},
  removeFile,
  isFileUploadInProgress,
  batchUploadStatus,
  filePathGeneric,
  topicsForImport,
  setSelectedTopicsForImport,
  onTopicCreated = () => {},
  importScope,
  setImportScope,
  ...props
}) => {
  const { getWorkspaceEntities } = useWorkspaces();
  const [modalContentKey, setModalContentKey] = React.useState(null);
  const [documentToDelete, setDocumentToDelete] = useState(null);
  const [documentsToDelete, setDocumentsToDelete] = useState([]);
  const { currentTheme } = AppTheme.useTheme();
  const dimensions = useWindowDimensions();
  const coreViewHeight = dimensions.height - 200;
  const { state } = AppStateManager.useAppStateManager();
  const _styles = styleGenerator(currentTheme, coreViewHeight);
  const topics = getWorkspaceEntities("topic");
  const [normalisedTableItems, setNormalisedTableItems] = useState([]);
  const { t } = useTranslation();
  const newDocTypeOptions = useMemo(
    () =>
      (documentTypes || Constants.DOCUMENT_TYPES).map((u) => ({
        id: u.key,
        label: t(u.labelKey, { defaultValue: u.label }),
        icon: u.iconKey ? AppAssets.icons[u.iconKey] : undefined,
        iconColor: currentTheme?.theme?.primary,
      })),
    [documentTypes, t, currentTheme],
  );
  const newDocMenuLabelStyle = {
    fontWeight: "bold",
    fontSize: currentTheme?.theme?.small_font_size,
    color: currentTheme?.theme?.primary,
  };
  const newDocMenuContainerStyle = {
    alignSelf: "center",
    marginLeft: 10,
  };
  const largeColumns = [
    {
      title: t("documents.columns.id"),
      width: 0.05,
    },
    {
      title: t("documents.columns.title"),
      width: 0.1,
    },
    {
      title: t("documents.columns.document"),
      width: 0.45,
    },
    {
      title: t("documents.columns.topics"),
      width: 0.15,
    },
    {
      title: t("documents.columns.type"),
      width: 0.1,
    },
    {
      title: t("documents.columns.validation"),
      width: 0.1,
    },
    {
      title: t("documents.columns.actions"),
      width: 0.00001,
    },
  ];
  const smallColumns = [
    {
      title: t("documents.columns.id"),
      width: 0.2,
    },
    {
      title: t("documents.columns.title"),
      width: 0.4,
    },
    {
      title: t("documents.columns.actions"),
      width: 0.00001,
    },
  ];
  const [columns, setColumns] = useState(largeColumns);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const typeLabelFor = (key) => {
    const match = (documentTypes || Constants.DOCUMENT_TYPES)?.find(
      (u) => u.key === key,
    );
    return match ? t(match.labelKey, { defaultValue: match.label || key }) : key;
  };
  const getRawDocument = (item) => {
    const _item = item?.item || item;
    return trainingData?.data?.find((u) => u?.id == _item?.id);
  };
  const isImportedDocument = (item) => !!getRawDocument(item)?.external_path;
  const isEmpty = !requestInProgress && !hasAnyData;
  useEffect(() => {
    setNormalisedTableItems(
      trainingData?.data?.map(
        (u) => {
          const titleNode =
            u?.document && u?.document[0]?.type === "title"
              ? u.document[0]
              : emptyTitleValue[0];
          const entities = [];
          if (u?.trainingdata?.data?.length > 0) {
            u?.trainingdata?.data?.map((u) => {
              if (u.UniqueEntities?.length > 0)
                entities.push(...u.UniqueEntities);
            });
          }
          u?.topics?.map((u) => {
            const match = topics?.filter((t) => t?.id === u)[0]?.label;
            if (match) {
              entities.push(match);
            }
          });
          if (
            (u?.document &&
              u?.document?.filter((e) => e.type !== "title")?.length > 0) ||
            u?.external_path
          )
            if (isLargeScreen())
              return {
                id: u?.id?.toString(),
                title: u?.external_path
                  ? u?.title
                  : AppQuantumEditorUtils.Helpers.generateStringFromElement(
                      titleNode,
                    ) || "",
                document: u?.external_path
                  ? t("documents.importedFile")
                  : AppQuantumEditorUtils.Helpers.getPlainText(u?.document),
                meta: [...new Set(entities)]?.join(", "),
                type: typeLabelFor(u.type),
                validation:
                  u?.scope === "validation"
                    ? t("common.yes")
                    : t("common.no"),
                actions: " ",
              };
            else {
              return {
                id: u?.id?.toString(),
                title: u?.external_path
                  ? u?.title
                  : AppQuantumEditorUtils.Helpers.generateStringFromElement(
                      titleNode,
                    ) || "",
                actions: " ",
              };
            }
        },
        [isLargeScreen()],
      ),
    );
    if (isLargeScreen()) setColumns(largeColumns);
    else setColumns(smallColumns);
  }, [trainingData?.data, isLargeScreen()]);
  const generateModalTitle = (modalContentKey) => {
    if (modalContentKey === "DELETE_DOC")
      return t("documents.modals.deleteDocument");
    else if (modalContentKey === "EXPORT")
      return t("documents.modals.exportWizard");
  };
  return (
    <AppBaseScreen
      isScrollable={true}
      contentContainerStyle={{
        // overflow: "auto",
        minHeight: 450,
      }}
    >
      <View
        style={{
          paddingHorizontal: 20,
          paddingTop: 10,
          minWidth: minAppWidth(),
        }}
      >
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <PageTitle>{t("documents.title")}</PageTitle>
            <ToothFairySupportButton />
            {!isEmpty && (
              <>
                <ToothFairyButton
                  {...Styles.minifiedButtonStyle}
                  accessibilityLabel="importButton"
                  title={t("documents.importData")}
                  onPress={() => {
                    setIsImportWizardOpen(true);
                  }}
                  isDisabled={!isImportEnabled}
                />
                <AppButtonMenu
                  containerStyle={newDocMenuContainerStyle}
                  labelStyle={newDocMenuLabelStyle}
                  chevronSize={12}
                  chevronColor={currentTheme?.theme?.primary}
                  mainActionLabel={t("documents.createNewDoc")}
                  onClickMainAction={() => {
                    if (!state?.isWorkspaceReady || createAPIInProgress) return;
                    handleDocumentCreation();
                  }}
                  options={newDocTypeOptions}
                  onClickMenuItem={(id) => {
                    if (!state?.isWorkspaceReady || createAPIInProgress) return;
                    handleDocumentCreation(id);
                  }}
                />
              </>
            )}
          </View>
          <View style={{ flexDirection: "column" }}>
            {isImportInProgress && (
              <Notification
                label={t("documents.trainingDataImportInProgress")}
                dotValue={1}
                color={"orange"}
              />
            )}
            {isImportStarted && (
              <AppText
                isClickable
                isHoverable={false}
                leftIcon={AppAssets.icons.close}
                color={currentTheme?.theme?.red}
                onPress={stopImportProcess}
                iconSize={16}
                wrapperStyle={{
                  alignSelf: "flex-end",
                  marginTop: 10,
                }}
                style={{
                  paddingLeft: 10,
                }}
              >
                {t("documents.abortImport")}
              </AppText>
            )}
          </View>
        </View>
        <View style={{ zIndex: -1, height: dimensions.height - 75 }}>
          {requestInProgress ? (
            <>
              <LoadingPlaceholder
                style={{
                  marginTop: 50,
                }}
                containerStyle={{
                  ..._styles.animation,
                  minHeight: 150,
                  justifyContent: "flex-end",
                }}
                visible={true}
                caption={t("documents.loadingDocuments")}
              />
              {isImportInProgress && <AppText>{importProgress}</AppText>}
            </>
          ) : hasAnyData ? (
            <AppTable
              style={{
                zIndex: -1,
                height: dimensions.height - 180,
                minHeight: 180,
                overflow: "auto",
                padding: 0,
                marginTop: 10,
                maxWidth: isMobileScreen() && dimensions.width - 15,
              }}
              headers={columns}
              showPagination
              itemsPerPage={25}
              items={normalisedTableItems}
              hideSearch={false}
              searchPlaceholder={t("documents.searchPlaceholder", {
                defaultValue: "Search by id, title or topic...",
              })}
              mapSelectionIconWithStatus={(item) => {
                if (
                  trainingData?.data?.find((u) => u?.id === item?.id)
                    ?.source === "dataImporter"
                )
                  return AppAssets?.icons?.download;
              }}
              actionButtons={true}
              showDropDownMenuForActions
              isSelectable={true}
              bulkActions={[
                {
                  id: "DELETE",
                  label: t("common.delete"),
                  icon: AppAssets.icons.delete,
                  isDestructive: true,
                },
              ]}
              onBulkActionPress={(id, selectedItems) => {
                if (id === "DELETE") {
                  setDocumentsToDelete(selectedItems || []);
                  setModalContentKey("DELETE_DOC");
                  setIsDeleteModalOpen(true);
                }
              }}
              mainActionLabel={(item) =>
                isImportedDocument(item)
                  ? t("downloadModal.download")
                  : t("common.view")
              }
              onClickMainAction={(item, index) => {
                handleDocumentSelection(item, index);
              }}
              onActionItemPress={(id, item, index) => {
                if (id === "EDIT" || id === "DOWNLOAD") {
                  handleDocumentSelection(item, index);
                } else if (id === "DELETE") {
                  setModalContentKey("DELETE_DOC");
                  setDocumentToDelete(item);
                  setIsDeleteModalOpen(true);
                }
              }}
              actions={(item) =>
                isImportedDocument(item)
                  ? [
                      {
                        label: t("downloadModal.download"),
                        id: "DOWNLOAD",
                        icon: AppAssets.icons.download,
                      },
                      {
                        label: t("common.delete"),
                        id: "DELETE",
                        icon: AppAssets.icons.delete,
                      },
                    ]
                  : [
                      {
                        label: t("common.edit"),
                        id: "EDIT",
                        icon: AppAssets.icons.edit,
                      },
                      {
                        label: t("common.delete"),
                        id: "DELETE",
                        icon: AppAssets.icons.delete,
                      },
                    ]
              }
              isItemActionable={(item) => {
                const match = trainingData?.data?.filter(
                  (u) => u.id == item.id,
                )[0];
                return match?.source !== "api";
              }}
            >
              <View style={{ flexDirection: "row", alignItems: "center" }}>
                <AppDropDown
                  dropDownStyle={{
                    // width: 220,
                    borderColor: currentTheme?.theme?.border_color,
                  }}
                  wrapperContainer={{
                    marginRight: 10,
                    width: 180,
                  }}
                  isElevated={false}
                  dropdownIconColor="transparent"
                  items={[
                    {
                      id: "all",
                      label: t("documents.columns.allTypes", {
                        defaultValue: "All types",
                      }),
                    },
                    ...(documentTypes || Constants.DOCUMENT_TYPES)?.map(
                      (u) => ({
                        id: u.key,
                        label: t(u.labelKey, { defaultValue: u.label }),
                      }),
                    ),
                  ]}
                  propertyLabel="label"
                  propertyValue="id"
                  selectedValue={typeFilter}
                  onValueChange={(v) => setTypeFilter(v)}
                />
                <ToothFairySwitch
                  wrapperStyle={{
                    width: "auto",
                    minWidth: 150,
                    paddingRight: 6,
                  }}
                  label={t("documents.excludeValidation")}
                  onChange={(v) => {
                    handleExcludeValidation(v);
                  }}
                  isTicked={excludeValidation}
                />
              </View>
            </AppTable>
          ) : (
            <View
              style={{
                width: "100%",
                alignItems: "center",
                justifyContent: "center",
                marginVertical: 20,
              }}
            >
              <AppPlaceholderView
                wrapperStyle={{
                  width: "100%",
                  height: "auto",
                  marginHorizontal: "auto",
                  justifyContent: "center",
                }}
                size={30}
                icon={AppAssets.icons.orbit}
                mainCaption={t("documents.emptyPlaceholder")}
                subCaption={t("documents.emptySubCaption")}
              />
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  marginLeft: 10,
                }}
              >
                <ToothFairyButton
                  accessibilityLabel="importButton"
                  title={t("documents.importData")}
                  onPress={() => {
                    setIsImportWizardOpen(true);
                  }}
                  {...Styles.minifiedButtonStyle}
                  isDisabled={!isImportEnabled}
                />
                <AppButtonMenu
                  containerStyle={newDocMenuContainerStyle}
                  labelStyle={newDocMenuLabelStyle}
                  chevronSize={12}
                  chevronColor={currentTheme?.theme?.primary}
                  mainActionLabel={t("documents.createNewDoc")}
                  onClickMainAction={() => {
                    if (!state?.isWorkspaceReady || createAPIInProgress) return;
                    handleDocumentCreation();
                  }}
                  options={newDocTypeOptions}
                  onClickMenuItem={(id) => {
                    if (!state?.isWorkspaceReady || createAPIInProgress) return;
                    handleDocumentCreation(id);
                  }}
                />
              </View>
            </View>
          )}
        </View>
        <AppModal
          modalScrollContainer={{
            justifyContent: "space-around",
          }}
          modalBackdrop={true}
          modalBackdropStatic={true}
          modalStyle={{
            ..._styles.modalInput,
            height: 330,
          }}
          modalTitle={generateModalTitle(modalContentKey)}
          isCloseButtonVisible
          closeModal={() => {
            setIsDeleteModalOpen(false);
          }}
          isModalVisible={isDeleteModalOpen}
          transparent={true}
        >
          <AppChoice
            wrapperStyle={{
              alignSelf: "center",
              maxWidth: 600,
              marginTop: 50,
            }}
            cancelCaption={t("documents.deleteCancelCaption")}
            confirmCaption={t("documents.deleteConfirmCaption")}
            onConfirmButtonPress={() => {
              if (documentsToDelete.length > 0)
                handleBulkDocumentDeletion(documentsToDelete);
              else handleDocumentDeletion(documentToDelete);
              setIsDeleteModalOpen(false);
              setDocumentsToDelete([]);
              setModalContentKey("");
            }}
            onCancelButtonPress={() => {
              setIsDeleteModalOpen(false);
              setDocumentToDelete(null);
              setDocumentsToDelete([]);
              setModalContentKey("");
            }}
            AppChoiceButton={ToothFairyButton}
            caption={
              documentsToDelete.length > 0
                ? t("documents.deleteBulkCaption", {
                    count: documentsToDelete.length,
                    defaultValue: "You are about to delete {{count}} documents",
                  })
                : t("documents.deleteCaption")
            }
            subCaption={t("documents.deleteSubCaption")}
          />
        </AppModal>

        {/* LIST OF EDITORS WITH SPECIFIC MODE FOR DISPLAY NOT EDITABLE */}
      </View>
      <DocumentsImportWizard
        isModalOpen={isImportWizardOpen}
        setIsModalOpen={setIsImportWizardOpen}
        documentTypes={documentTypes}
        selectedImportType={selectedImportType}
        setSelectedImportType={setSelectedImportType}
        filePathGeneric={filePathGeneric}
        handleFileSelect={handleFileSelect}
        handleImportsGeneric={handleImportsGeneric}
        removeFile={removeFile}
        batchUploadStatus={batchUploadStatus}
        isFileUploadInProgress={isFileUploadInProgress}
        topicsForImport={topicsForImport}
        setSelectedTopicsForImport={setSelectedTopicsForImport}
        importScope={importScope}
        setImportScope={setImportScope}
        onTopicCreated={onTopicCreated}
      />
    </AppBaseScreen>
  );
};
const styleGenerator = (props, coreViewHeight) => {
  return StyleSheet.create({
    title: {
      fontSize: 26,
    },
    list: {
      minHeight: coreViewHeight,
    },
    animation: {
      backgroundColor: props?.theme?.transparent,
      minHeight: coreViewHeight,
    },
    paginationWrapper: {
      marginTop: 10,
      alignSelf: "flex-end",
    },
    modalInput: {
      height: 280,
      marginHorizontal: "auto",
      marginVertical: "auto",
      width: 500,
    },
  });
};

export default DocumentsScreen;
